import produce, { castDraft, } from 'immer';
import { UserLogsActionType, } from './actions';
const messageLogsByUserIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case UserLogsActionType.SET_USER_MESSAGE_LOGS:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const temp = draft[actualAction.userId] || {};
                draft[actualAction.userId] = temp;
                temp[actualAction.searchParams] = castDraft(actualAction.entries);
            });
        default:
            return currentState;
    }
};
const httpLogsByUserIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case UserLogsActionType.SET_USER_HTTP_LOGS:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const temp = draft[actualAction.userId] || {};
                draft[actualAction.userId] = temp;
                temp[actualAction.searchParams] = castDraft(actualAction.entries);
            });
        default:
            return currentState;
    }
};
export const userLogsStateReducer = (currentState, action) => {
    return produce(currentState, (draft) => {
        draft.messageLogsByUserId = castDraft(messageLogsByUserIdReducer(currentState.messageLogsByUserId, action));
        draft.httpLogsByUserId = castDraft(httpLogsByUserIdReducer(currentState.httpLogsByUserId, action));
    });
};
